const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="footer-brand">
                    <h2>SamparkBindhu™</h2>
                    {/* <p>Connecting People. Empowering Growth.</p> */}
                </div>

                <div className="footer-info">
                    <p>© 2021–2026 SamparkBindhu Trade Solutions Private Limited</p>
                    <p>
                        SamparkBindhu Trade Solutions Private Limited
                        Godown No:2, Survey No 36/1, Situated At GOLAHALLI Village, <br/>Anajanapura Post , Bengaluru -560108
                    </p>
                </div>

                <div className="footer-social">
                    <a href="https://www.linkedin.com/company/samparkbindhu/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://x.com/samparkbindhu" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.facebook.com/gundlupet.murthy/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};
export default Footer;